import { useSummaryDialog } from './lib/useSummaryDialog';
import React from 'react';
import { X, Truck, TrendingUp, DollarSign, Trophy , BarChart3, ExternalLink} from 'lucide-react';

export default function ExpedicaoTotal({ data, onClose, onOpenDashboard }) {
    const { titleId, dialogRef, closeRef, onKeyDown } = useSummaryDialog(onClose);

    const formatBRL = (val) =>
        Number(val || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

    return (
        <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/80 backdrop-blur-sm p-2 sm:p-4">
            <div ref={dialogRef} role="dialog" aria-modal="true" aria-labelledby={titleId} onKeyDown={onKeyDown} className="flex max-h-[calc(100dvh-1rem)] sm:max-h-[calc(100dvh-2rem)] min-h-0 flex-col bg-[#0d1117] border border-gray-800 w-full max-w-3xl rounded-lg shadow-2xl overflow-hidden">

                {/* Cabeçalho */}
                <div className="flex shrink-0 justify-between items-center gap-3 p-3 sm:p-4 border-b border-gray-800 bg-[#161b22]">
                    <div className="flex min-w-0 items-center gap-2 text-orange-400 font-bold tracking-wide sm:tracking-widest text-[10px] sm:text-xs uppercase">
                        <Truck size={18} className="shrink-0" />
                        <h2 id={titleId} className="min-w-0 break-words">Detalhamento de Expedição</h2>
                    </div>
                    <button type="button" ref={closeRef} onClick={onClose} aria-label="Fechar Detalhamento de Expedição" className="flex h-11 w-11 shrink-0 items-center justify-center rounded border border-gray-700 text-gray-200 hover:bg-gray-700 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-yellow-500 transition-colors">
                        <X size={20} />
                    </button>
                </div>

                {/* Grade de Métricas */}
                <div className="min-h-0 overflow-y-auto overscroll-contain p-3 sm:p-6 grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">

                    <div className="bg-[#161b22] p-4 rounded border border-gray-800">
                        <div className="flex justify-between mb-2">
                            <p className="text-gray-500 text-[10px] uppercase font-bold italic tracking-tighter">Expedição do Dia</p>
                            <DollarSign size={14} className="text-gray-600" />
                        </div>
                        <p className="text-white text-xl sm:text-2xl break-words font-mono font-bold">
                            {formatBRL(data?.totalExpedicaoDia || 0)}
                        </p>
                    </div>

                    <div className="bg-[#161b22] p-4 rounded border border-gray-800">
                        <div className="flex justify-between mb-2">
                            <p className="text-gray-500 text-[10px] uppercase font-bold italic tracking-tighter">Total Expedido (Mês)</p>
                            <TrendingUp size={14} className="text-gray-500" />
                        </div>
                        <p className="text-gray-300 text-xl sm:text-2xl break-words font-mono font-bold">
                            {formatBRL(data?.totalExpedicao || 0)}
                        </p>
                    </div>


                    <div className="bg-[#161b22] p-4 rounded border border-gray-800">
                        <div className="flex justify-between mb-2">
                            <p className="text-gray-500 text-[10px] uppercase font-bold italic tracking-tighter">Maior Expedição (Mês)</p>
                            <Trophy size={14} className="text-amber-500" />
                        </div>
                        <p className="text-gray-500 text-xl sm:text-2xl break-words font-mono font-bold">
                            {formatBRL(data?.totalExpedicaomaior)}
                        </p>
                    </div>
                    <div className="bg-[#161b22] p-4 rounded border border-gray-800 flex flex-col justify-between">
                        <div className="flex items-center justify-between mb-2">
                            <p className="text-gray-500 text-[10px] uppercase font-bold italic tracking-tighter">Frete do Mês</p>
                            <Truck size={14} className="text-red-500 opacity-70" />
                        </div>
                        <p className="text-red-400 text-xl sm:text-2xl break-words font-mono font-bold tracking-tighter">
                            {formatBRL(data?.totalfrete)}
                        </p>
                    </div>
                    <div className="bg-[#161b22] p-4 rounded border border-gray-800 flex flex-col justify-between">
                        <div className="flex items-center justify-between mb-2">
                            <p className="text-gray-500 text-[10px] uppercase font-bold italic tracking-tighter">Valor Líquido (- Frete Pago)</p>
                            <Truck size={14} className="text-red-500 opacity-70" />
                        </div>
                        <p className="text-blue-600 text-xl sm:text-2xl break-words font-mono font-bold tracking-tighter">
                            {formatBRL(data?.vlrLiquidoFrete)}
                        </p>
                    </div>
                    <div className="bg-[#161b22] p-4 rounded border border-gray-800 flex flex-col justify-between">
                        <div className="flex items-center justify-between mb-2">
                            <p className="text-gray-500 text-[10px] uppercase font-bold italic tracking-tighter">Valor médio(R$/m³)</p>
                            <Truck size={14} className="text-red-500 opacity-70" />
                        </div>
                        <p className="text-blue-400 text-xl sm:text-2xl break-words font-mono font-bold tracking-tighter">
                            {formatBRL(data?.mediamEntregue)}
                        </p>
                    </div>
                    <div className="md:col-span-2">
                        <button
                            type="button"
                            onClick={onOpenDashboard}
                            className="group flex w-full items-center justify-center gap-2 rounded-lg border border-blue-500/30 bg-blue-600/10 py-3 text-blue-400 transition-all hover:bg-blue-600/20"
                        >
                            <BarChart3 size={16} className="transition-transform group-hover:scale-110" />
                            <span className="text-[10px] font-black uppercase tracking-[0.2em]">Abrir painel Expedição</span>
                            <ExternalLink size={14} className="opacity-50" />
                        </button>
                    </div>
                </div>

                {/* Rodapé */}
                <div className="shrink-0 p-3 sm:p-4 bg-[#0d1117] text-right border-t border-gray-800">
                    <button
                        onClick={onClose}
                        className="min-h-11 w-full sm:w-auto bg-gray-800 hover:bg-gray-700 text-white text-xs font-black py-3 px-8 rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-yellow-500 transition-all uppercase tracking-widest shadow-lg"
                    >
                        Fechar Janela
                    </button>
                </div>
            </div>
        </div>
    );
}